import React, { useEffect, useState } from 'react';
import { Col, DatePicker, Form, Input, Modal, notification, Row, Space, Table } from 'antd';
import Button from 'mixins/ui/button/button';
import { IAnswerData, IShownComponents } from '../express-help.types';
import Link from 'antd/es/typography/Link';
import BtnReturnBack from '../BtnReturnBack';
import AnswerEditModal from '../modals/modal-answer-edit';
import {
    deleteAnswerById,
    getAnswerList,
    getAnswersByQuestionId,
    searchAnswer,
} from '/react4xp/parts/express-help/actions';

const QuestionItemScreen = (props: any) => {
    const [selectedObject, setSelectedObject] = useState<IAnswerData>();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const [data, setData] = useState<IAnswerData[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    const { confirm } = Modal;
    const [form] = Form.useForm();

    const moveToScreen = (nextScreenParameter: IShownComponents) => {
        props.showNext(nextScreenParameter);
    };

    const onFinish = (values) => {
        searchAnswer(values).then((response) => {
            setData(response.data);
        });
    };

    const loadAnswers = () => {
        setIsLoading(true);

        if (props.showObject.idOfQuestion && props.showObject.idOfQuestion > 0) {
            getAnswersByQuestionId(props.showObject.idOfQuestion)
                .then((response) => {
                    setData(response.data);
                })
                .finally(() => setIsLoading(false));
        } else {
            getAnswerList()
                .then((response) => {
                    setData(response.data);
                })
                .finally(() => setIsLoading(false));
        }
    };

    const deleteOne = (id: number) => {
        confirm({
            title: 'Подтвердите действия удаления данных',
            onOk() {
                deleteAnswerById(id)
                    .then(() => {
                        notification['success']({
                            message: 'Данные успешно удалены!',
                        });
                        loadAnswers();
                    })
                    .catch(() => {
                        notification['error']({
                            message: 'Ошибка',
                            description:
                                'Для удаления ответа пожалуйста удалите результат от ответа',
                        });
                    });
            },
        });
    };

    const edit = (doc: any) => {
        setIsModalOpen(true);
        setSelectedObject(doc);
    };

    const onActionClick = (key: string, doc: any) => {
        switch (key) {
            case 'EDIT':
                edit(doc);
                break;
            case 'DELETE':
                deleteOne(doc.id);
                break;
        }
    };

    const handleOk = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
        loadAnswers();
    };

    const handleCancel = () => {
        setSelectedObject(null);
        setIsModalOpen(false);
        loadAnswers();
    };

    const columns = [
        {
            title: 'ИД',
            dataIndex: 'externalAnswerId',
        },
        {
            title: 'Ответ на казахском языке',
            dataIndex: 'answerKk',
        },
        {
            title: 'Ответ на русском языке',
            dataIndex: 'answerRu',
        },
        {
            title: 'Ответ на английском языке',
            dataIndex: 'answerEn',
        },
        {
            title: 'Изменил',
            dataIndex: 'username',
        },
        {
            title: 'Действия',
            width: 180,
            render: (text, record) => (
                <span>
                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('DELETE', record);
                        }}
                    >
                        Удалить
                    </Link>

                    <Link
                        className="column-button"
                        style={{ marginRight: 3 }}
                        onClick={() => {
                            onActionClick('EDIT', record);
                        }}
                    >
                        Редактировать
                    </Link>
                </span>
            ),
        },
    ];

    useEffect(() => {
        loadAnswers();
    }, []);

    const onReturnBackHandler = () => {
        const nextPageParameter: IShownComponents = {
            mainPageShown: false,
            pollPageShown: false,
            questionPageShown: false,
            answerPageShown: false,
            editMode: props.showObject.editMode,
            pollItemPageShown: true,
            idOfQuestionnaire: props.showObject.idOfQuestionnaire,
            idOfQuestion: props.showObject.idOfQuestion,
        };

        if (!nextPageParameter.editMode) {
            nextPageParameter.pollItemPageShown = false;
            nextPageParameter.pollPageShown = true;
        }

        props.showNext(nextPageParameter);
    };

    const clear = () => {
        form.resetFields();
    };

    return (
        <div className="poll-screen">
            <BtnReturnBack handler={onReturnBackHandler} />

            <h4 className="my-3">Ответы</h4>

            <Form
                name="createQueston"
                form={form}
                layout="vertical"
                onFinish={onFinish}
            >
                <Row gutter={{ xs: 8, md: 16 }}>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="username"
                            label="Изменил"
                        >
                            <Input placeholder="Введите" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="changeDateFrom"
                            label="Дата изменения C"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                    <Col
                        xs={24}
                        md={8}
                    >
                        <Form.Item
                            name="changeDateTo"
                            label="По"
                        >
                            <DatePicker picker="date" />
                        </Form.Item>
                    </Col>
                </Row>

                <Space wrap>
                    <Button onClick={clear}>Сброс</Button>
                    <Button
                        type="primary"
                        htmlType="submit"
                        color="gold"
                    >
                        Поиск
                    </Button>
                </Space>
            </Form>

            <Row
                gutter={{ xs: 24, md: 24 }}
                className="my-3"
                justify="space-between"
            >
                <Col>
                    <h4 className="express-help-list">Список ответов</h4>
                </Col>
                <Col>
                    <Button
                        color="gold"
                        onClick={() => {
                            moveToScreen({
                                mainPageShown: false,
                                pollPageShown: false,
                                questionPageShown: false,
                                answerPageShown: true,
                                idOfQuestionnaire: props.showObject.idOfQuestionnaire,
                                idOfQuestion: props.showObject.idOfQuestion,
                                editMode: true,
                            });
                        }}
                    >
                        Добавить ответ
                    </Button>
                </Col>
            </Row>

            <Table
                className="my-3"
                dataSource={data}
                columns={columns}
                loading={isLoading}
                scroll={{
                    x: true,
                }}
            />

            <AnswerEditModal
                isModalOpen={isModalOpen}
                handleOk={handleOk}
                handleCancel={handleCancel}
                selectedObject={selectedObject}
                questionnaireId={props.showObject.idOfQuestionnaire}
            />
        </div>
    );
};

export default QuestionItemScreen;
